import { useRef } from "react";

export function useSetDebounceValue<T>(
  callback: (val: T) => void,
  delay: number
) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const setValueDebounced = (val: T) => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(val);
    }, delay);
  };

  return {
    setValueDebounced,
    clearDebounce: () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    },
  };
}
